/* eslint-disable array-callback-return */
import React, { useRef, useState } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import { NavLink } from "react-router-dom";
import {
  TextField,
  Button,
  Alert,
  Avatar,
  Paper,
  Typography,
  FormControl,
  Snackbar,
  Grid,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Link,
  Breadcrumbs,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

import { Formik, getIn } from "formik";
import DocumentUpload from "../components/DocumentUpload";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";
import { connect } from "react-redux";
import UpdatePlateDetails from "./UpdatePlateDetails";
import swal from "sweetalert";

let states = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Lakshadweep",
  "Puducherry",
];

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;
const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function Signup({ setCurrent, setCompany }) {
  const [images, setImages] = useState({});
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState("");
  const formData = new FormData();
  const [documents, setDocuments] = useState({});

  const [loader, setLoader] = useState(false);

  const [expanded, setExpanded] = useState(0);

  const handleExpandedChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const inputFile = useRef(null);
  const onButtonClick = () => {
    inputFile.current.click();
  };
  const [profile, setProfile] = useState();

  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const registerCustomer = async (
    formData,
    name,
    email_address,
    addresses,
    default_address,
    credit_sum,
    description,
    gst_number,
    pan_number,
    phone_number,
    landline_number,
    resetForm,
    setImages,
    images,
    setLoader
  ) => {
    try {
      var br = 0;
      Object.values(images).map((doc, i) => {
        if (!documents[i]) {
          setErr("Document Name field cannot be empty");
          setSuccess(false);
          snackRef.current.click();
          br = 1;
          return;
        }
      });
      if (!br) {
        setLoader(true);
        formData.set("name", name);
        formData.set("email_address", email_address);
        formData.set("addresses", JSON.stringify(addresses));
        formData.set("default_address", default_address);
        if (phone_number[0] !== "+") {
          let numberWithCode = `+91${phone_number}`;
          formData.set("phone_number", numberWithCode);
        } else {
          formData.set("phone_number", phone_number);
        }
        formData.set("credit_sum", credit_sum);
        formData.set("gst_number", gst_number);
        formData.set("pan_number", pan_number);
        formData.set("description", description);
        formData.set("landline_number", landline_number);

        if (profile) {
          formData.set("profile_picture", profile);
        }
        Object.values(images).map((image, i) => {
          formData.set(`document_${i + 1}_file`, image);
        });
        Object.values(documents).map((doc, i) => {
          formData.set(`document_${i + 1}_name`, doc);
        });
        const userData = JSON.parse(localStorage.getItem("AuthData"));
        const config = {
          headers: {
            Authorization: "Bearer " + userData.access_token,
          },
        };
        const { data } = await axios.post(
          `/api/v1/${userData.type}/customer_company?limit=500`,
          formData,
          config
        );
        if (data.success) {
          setLoader(false);
          setSuccess(true);
          setErr("");
          resetForm({ values: "" });
          setImages({});
          snackRef.current.click();
          setCurrent(1);
          setCompany(data.data._id);
        }
      }
    } catch (e) {
      setLoader(false);
      setErr(e.response.data.error);
      console.log(e);
      snackRef.current.click();
    }
  };

  const getCompaniesByPanNumber = async (pan_number) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/${userData.type}/customer_company/companies/${pan_number}`,
        config
      );
      let text = ``;
      data?.data?.map((cmp, i) => {
        text += `${i + 1} ${cmp.name} \n`
      })
      return text;
    } catch (e) {
      setErr(e.response.data.error || "Something went wrong");
      console.log(e);
      snackRef.current.click();
    }
  };

  let initialValues = {
    name: "",
    email_address: "",
    description: "",
    credit_sum: "",
    gst_number: "",
    pan_number: "",
    phone_number: "",
    landline_number: "",
    addresses: [
      {
        address_line_one: "",
        address_line_two: "",
        pincode: "",
        state: "",
        city: "",
      },
    ],
    default_address: 0,
    submit: false,
  };
  function onAddAddress(values, setValues) {
    // update dynamic form
    const addresses = [...values.addresses];
    let newAddress = {
      address_line_one: "",
      address_line_two: "",
      pincode: "",
      state: "",
      city: "",
    };
    addresses.push(newAddress);
    setValues({ ...values, addresses });
  }

  function onRemoveAddress(index, values, setValues) {
    // update dynamic form
    const addresses = [...values.addresses];
    if (addresses.length > 1) {
      addresses.splice(index, 1);
    }
    let default_address = values.default_address;
    if (default_address === index) {
      default_address -= 1;
    }
    setValues({ ...values, default_address, addresses });
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        email_address: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
        name: Yup.string().max(255).required("name is required"),
        addresses: Yup.array().of(
          Yup.object().shape({
            address_line_one: Yup.string()
              .max(1000)
              .required("Address Line 1 is required"),
            address_line_two: Yup.string()
              .max(1000)
              .required("Address Line 2 is required"),
            pincode: Yup.string()
              .required("Pincode is required")
              .length(6, "Pincode should have 6 digits"),
            state: Yup.string().required("State is required"),
            city: Yup.string().required("City is required"),
          })
        ),
        phone_number: Yup.string()
          .required("Phone Number is required")
          .matches(/^(((\+){1}91){1})?[6-9]{1}[0-9]{9}$/, {
            message: "Invalid Indian number",
            excludeEmptyString: false,
          }),
        description: Yup.string().max(1000).required("Description is required"),
        gst_number: Yup.string()
          .length(15, "GST Number should be 15 characters")
          .required("GST Number is Required"),
        pan_number: Yup.string()
          .required("PAN Number is Required")
          .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN Number"),
        credit_sum: Yup.string().required("Credit Term is required"),
      })}
      onSubmit={async (
        values,
        { setErrors, setStatus, setSubmitting, resetForm }
      ) => {
        try {
          const data = await getCompaniesByPanNumber(values.pan_number);
          if (data.length > 0) {
            swal({
              title: "Pan card already exist",
              text: `Following companies are registered with same pan card, do you still want to proceed? \n \n ${data}`,
              icon: "warning",
              buttons: ["No", "Yes"],
            }).then((res) => {
              if (res) {
                registerCustomer(
                  formData,
                  values.name,
                  values.email_address,
                  values.addresses,
                  values.default_address,
                  values.credit_sum,
                  values.description,
                  values.gst_number,
                  values.pan_number,
                  values.phone_number,
                  values.landline_number,
                  resetForm,
                  setImages,
                  images,
                  setLoader
                );
              } 
            });
           
          }else{
            registerCustomer(
              formData,
              values.name,
              values.email_address,
              values.addresses,
              values.default_address,
              values.credit_sum,
              values.description,
              values.gst_number,
              values.pan_number,
              values.phone_number,
              values.landline_number,
              resetForm,
              setImages,
              images,
              setLoader
            );
          }
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        setFieldValue,
        handleSubmit,
        setFieldTouched,
        isSubmitting,
        touched,
        values,
        setValues,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={1} severity="warning">
              {errors.submit}
            </Alert>
          )}
          <Button
            ref={snackRef}
            style={{ display: "none" }}
            onClick={handleClick({ vertical: "top", horizontal: "center" })}
          >
            Click
          </Button>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            onClose={handleClose}
            key={vertical + horizontal}
          >
            {err ? (
              <Alert mt={2} mb={4} severity="error">
                {err}
              </Alert>
            ) : success ? (
              <Alert mt={2} mb={4} severity="success">
                Customer Company Registered Successfully
              </Alert>
            ) : null}
          </Snackbar>
          {!loader ? (
            <Grid container spacing={5}>
              <Grid item xs={12} md={12} lg={12}>
                <BigAvatar
                  style={{ cursor: "pointer" }}
                  onClick={onButtonClick}
                  src={profile ? URL.createObjectURL(profile) : ""}
                />
                <input
                  type="file"
                  id="file"
                  ref={inputFile}
                  accept=".png, .jpg, .jpeg"
                  onChange={(e) => setProfile(e.target.files[0])}
                  style={{ display: "none" }}
                />
                <Typography
                  component="h1"
                  variant="h4"
                  align="center"
                  gutterBottom
                >
                  Add Profile Picture
                </Typography>
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <TextField
                  type="text"
                  name="name"
                  label="name"
                  value={values.name}
                  fullWidth
                  error={Boolean(touched.name && errors.name)}
                  helperText={touched.name && errors.name}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <TextField
                  type="text"
                  name="description"
                  fullWidth
                  label="Description"
                  value={values.description}
                  error={Boolean(touched.description && errors.description)}
                  helperText={touched.description && errors.description}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <TextField
                  type="email"
                  fullWidth
                  name="email_address"
                  label="Email address"
                  value={values.email_address}
                  error={Boolean(touched.email_address && errors.email_address)}
                  helperText={touched.email_address && errors.email_address}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <TextField
                  type="text"
                  fullWidth
                  name="phone_number"
                  label="Phone Number"
                  value={values.phone_number}
                  error={Boolean(touched.phone_number && errors.phone_number)}
                  helperText={touched.phone_number && errors.phone_number}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} lg={12} md={12}>
                <TextField
                  type="text"
                  fullWidth
                  name="landline_number"
                  label="Landline Number"
                  value={values.landline_number}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} lg={12} md={12}>
                <TextField
                  type="text"
                  name="credit_sum"
                  label="Credit Term"
                  value={values.credit_sum}
                  fullWidth
                  error={Boolean(touched.credit_sum && errors.credit_sum)}
                  helperText={touched.credit_sum && errors.credit_sum}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <TextField
                  type="text"
                  name="gst_number"
                  fullWidth
                  label="GST Number"
                  value={values.gst_number}
                  error={Boolean(touched.gst_number && errors.gst_number)}
                  helperText={touched.gst_number && errors.gst_number}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <TextField
                  type="text"
                  name="pan_number"
                  fullWidth
                  label="PAN Number"
                  value={values.pan_number}
                  error={Boolean(touched.pan_number && errors.pan_number)}
                  helperText={touched.pan_number && errors.pan_number}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} lg={12} md={12}>
                {values.addresses.map((address, index) => {
                  const addressOne = `addresses[${index}].address_line_one`;
                  const touchedAddressOne = getIn(touched, addressOne);
                  const errorAddressOne = getIn(errors, addressOne);

                  const addressTwo = `addresses[${index}].address_line_two`;
                  const touchedAddressTwo = getIn(touched, addressTwo);
                  const errorAddressTwo = getIn(errors, addressTwo);

                  const pinCode = `addresses[${index}].pincode`;
                  const touchedPinCode = getIn(touched, pinCode);
                  const errorPinCode = getIn(errors, pinCode);

                  const stateInput = `addresses[${index}].state`;
                  const touchedState = getIn(touched, stateInput);
                  const errorState = getIn(errors, stateInput);

                  const city = `addresses[${index}].city`;
                  const touchedCity = getIn(touched, city);
                  const errorCity = getIn(errors, city);

                  return (
                    <Accordion
                      expanded={expanded === index}
                      onChange={handleExpandedChange(index)}
                      key={index}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>Address {index + 1}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid item xs={12} lg={12} md={12}>
                          <TextField
                            fullWidth
                            name={addressOne}
                            value={address.address_line_one}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label={"Address Line 1"}
                            error={Boolean(
                              touchedAddressOne && errorAddressOne
                            )}
                            helperText={
                              touchedAddressOne && errorAddressOne
                                ? errorAddressOne
                                : ""
                            }
                          />
                        </Grid>
                        <Grid item xs={12} mt={5} lg={12} md={12}>
                          <TextField
                            fullWidth
                            name={addressTwo}
                            value={address.address_line_two}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label={"Address Line 2"}
                            error={Boolean(
                              touchedAddressTwo && errorAddressTwo
                            )}
                            helperText={
                              touchedAddressTwo && errorAddressTwo
                                ? errorAddressTwo
                                : ""
                            }
                          />
                        </Grid>
                        <Grid item xs={12} mt={5} lg={12} md={12}>
                          <TextField
                            fullWidth
                            name={pinCode}
                            value={address.pincode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label={"Pincode"}
                            error={Boolean(touchedPinCode && errorPinCode)}
                            helperText={
                              touchedPinCode && errorPinCode ? errorPinCode : ""
                            }
                          />
                        </Grid>

                        <Grid item xs={12} mt={5} md={12} lg={12}>
                          <FormControl
                            fullWidth
                            error={Boolean(touchedState && errorState)}
                          >
                            <Autocomplete
                              id="combo-box-demo"
                              options={states}
                              value={address.state}
                              onChange={(event, newValue) => {
                                setFieldValue(stateInput, newValue || "");
                              }}
                              onBlur={handleBlur}
                              getOptionLabel={(option) => option}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={Boolean(touchedState && errorState)}
                                  helperText={
                                    touchedState && errorState ? errorState : ""
                                  }
                                  label="Select State"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} mt={5} lg={12} md={12}>
                          <TextField
                            fullWidth
                            name={city}
                            value={address.city}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label={"City"}
                            error={Boolean(touchedCity && errorCity)}
                            helperText={
                              touchedCity && errorCity ? errorCity : ""
                            }
                          />
                        </Grid>
                        <Grid item xs={12} mt={5} mb={5} lg={12} md={12}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={index === values.default_address}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setFieldValue("default_address", index);
                                    } else {
                                      setFieldValue("default_address", 0);
                                    }
                                  }}
                                />
                              }
                              label="Default Address"
                            />
                          </FormGroup>
                        </Grid>

                        <Grid container justifyContent={"flex-end"}>
                          <div>
                            {index !== 0 && (
                              <Button
                                sx={{ mr: 3 }}
                                onClick={() => {
                                  onRemoveAddress(index, values, setValues);
                                }}
                                color="error"
                                variant="outlined"
                                endIcon={<DeleteIcon />}
                              >
                                Remove Address
                              </Button>
                            )}

                            {values.addresses.length === index + 1 && (
                              <Button
                                onClick={() => {
                                  onAddAddress(values, setValues);
                                }}
                                variant="outlined"
                                endIcon={<AddIcon />}
                              >
                                Add Address
                              </Button>
                            )}
                          </div>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
              </Grid>

              <Grid item xs={12} lg={12} md={12}>
                <DocumentUpload
                  images={images}
                  setImages={setImages}
                  documents={documents}
                  setDocuments={setDocuments}
                />
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                >
                  Register Customer Company
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Loading />
          )}
        </form>
      )}
    </Formik>
  );
}

function CustomerCompany({ auths }) {
  const [current, setCurrent] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [plates, setPlates] = useState([]);
  const [company, setCompany] = useState("");
  if (current === 0) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              REGISTER CUSTOMER COMPANY
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link
                component={NavLink}
                to="/dashboard/company/customer-companies"
              >
                Customer Companies
              </Link>
              <Typography> Register</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>
        <Wrapper>
          {/* <BigAvatar alt="Lucy" src="/static/img/avatars/icon.png" /> */}

          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Register Customer Company
          </Typography>
          {/* <Typography component="h2" variant="body1" align="center">
          Start creating the best possible user experience for you customers
        </Typography> */}
          <Signup setCompany={setCompany} setCurrent={setCurrent} />
        </Wrapper>
      </React.Fragment>
    );
  } else {
    return <UpdatePlateDetails company={company} plates={plates} />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(CustomerCompany);
